import { render, staticRenderFns } from "./CompraDiretaVisualizacaoAcoes.vue?vue&type=template&id=f228f712&scoped=true"
import script from "./CompraDiretaVisualizacaoAcoes.vue?vue&type=script&lang=js"
export * from "./CompraDiretaVisualizacaoAcoes.vue?vue&type=script&lang=js"
import style0 from "./CompraDiretaVisualizacaoAcoes.vue?vue&type=style&index=0&id=f228f712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f228f712",
  null
  
)

export default component.exports